<div class="search-container">
    <div id="search-box-header"></div>
</div>

<div id="hits" class="{{environmentClass}}"></div>
